type OverlayLoadingSpinnerProps = {
  loadingText: string;
};

export function OverlayLoadingSpinner(props: OverlayLoadingSpinnerProps) {
  return (
    <div
      className="fixed inset-0 z-[100] flex h-screen w-full items-center justify-center bg-black/50 max-sm:z-[110]"
      data-testid="overlay-loading-spinner"
    >
      <div className="flex flex-col items-center space-y-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-t-gray-900" />
        <p className="text-white">{props.loadingText}...</p>
      </div>
    </div>
  );
}
